import React from 'react'
import {connect} from 'react-redux'
import {saveTask,deleteTask} from '../actions'
import HandsonTable from '../components/HandsonTable'
import DatePicker from 'material-ui/DatePicker'
import RaisedButton from 'material-ui/RaisedButton'
import {MarkerList} from '../config'

import {BoltKeyMap} from '../utils/bolt'
import {parseBoltData} from '../utils/table'

const BoltIdSource = [...MarkerList,'']
const BoltTypeSource = Object.keys(BoltKeyMap).map(key=>BoltKeyMap[key])

const LogbookRebolt = React.createClass({
  displayName: 'LogbookRebolt',
  nestedHeaders: [
  ['','','','',{ label: '工作項目', colspan: 4 },''],
  ['編號','路線','Bolt','Bolt類型','洗洞','鑽洞','設置','移除','施工人員'],
  ],
  columns: [
  { data: 'rid', width:60},
  { data: 'name', readOnly: true,width:100},
  { data: 'bid', width:60, type: 'dropdown', source: BoltIdSource},
  { data: 'type',  width:150, type: 'dropdown', source:BoltTypeSource},
  { data: 'core', type: 'checkbox', width:100},
  { data: 'hole', type: 'checkbox', width:100},
  { data: 'bolt', type: 'checkbox', width:100},
  { data: 'removal', type: 'checkbox', width:100},
  { data: 'worker', width:200},
  ],
  getInitialState() {
    let date = yyyymmdd(new Date())
    let list = this.getList(date) || [{}]
    return {
      autoLoad: {},
      list,
      date,
    }
  },

  componentWillReceiveProps(nextProps) {
    if(!this.editing) {
      let list = this.getList(this.state.date,nextProps)|| [{}]
      this.setState({list})
    }
  },
  afterChange(data,index){
    this.editing = true
    let {rid,bid,type} = data
    let {list,autoLoad} = this.state
    let {routes} = this.props
    let {bolts,name} = routes[rid] || {}
    list = [...list]
    let needAddNew = false
    if(index === (list.length -1))
      needAddNew = true
    if(bolts && rid &&!bid &&!autoLoad[rid]) {
      autoLoad[rid] = true
      list = list.filter(task=>(task.rid!==rid && (task.rid ||task.bid)))
      Object.keys(bolts).forEach(bid=>{
        let {name:type}=parseBoltData(bolts[bid])
        list.push({rid,bid,type,name,hole:true,bolt:true})
        // list.push({rid,bid,type,name})
      })
      needAddNew = true
    }
    if(needAddNew){
      list.push({})
      this.setState({list,autoLoad})
    }

    if(!rid){
      if(this.timer)
        clearTimeout(this.timer)

      this.timer = setTimeout(()=>{
        list = this.state.list.filter(task=>(!!task.rid))
        list.push({})
        this.setState({list})
      },1000)
    }
    // console.log(rid,list,autoLoad)

  },
  getList(date,props){
    let {routes} = props || this.props
    let {tasks} = props || this.props
    tasks = tasks[date]
    if(!tasks)
      return null
    let list = Object.keys(tasks).map(id=>{
      let task = {...tasks[id]}
      task.type = BoltKeyMap[task.type]
      let route = routes[task.rid]
      route && (task.name = route.name)
      return task
    })
    list.push({})
    return list
  },
  onChangeDate(e,date){
    date = yyyymmdd(date)
    this.setState({date})

    let list = this.getList(date)
    list && this.setState({list})
  },

  doSave(){
    let {date,list} = this.state
    deleteTask(date)
    list.forEach(task=>{
      let {core,hole,bolt,removal,type} = task
      task = {...task}

      if(!core && !hole && !bolt && !removal)
        return
      if(!core) delete task.core
      if(!hole) delete task.hole
      if(!bolt) delete task.bolt
      if(!removal) delete task.removal
      delete task.name
      task.type = Object.keys(BoltKeyMap).filter(key=>BoltKeyMap[key]===type)[0]

      console.log('saveTask',task)
      saveTask(date,task)

    })
  },

  onSave(){
    if(window.confirm('確定送出?')){
      this.doSave()
    }
  },
  render() {
    let styles = {
      date:{
        margin:20,
        marginBottom:0,
        display: 'inline-block',

      },
      table:{
        margin:20,
        overflow:'auto',
        height:'100%',
      },
      button: {

      }
    }

    return (
      <div>
      <DatePicker
      style={styles.date}
      id="taskDate"
      defaultDate={new Date()}
      maxDate={new Date()}
      onChange={this.onChangeDate}/>
      <RaisedButton
      label="送出"
      primary={true}
      disabled={this.state.disabled}
      onTouchTap={this.onSave}
      style={styles.button} />

      <HandsonTable
      ref="table"
      style={styles.table}
      noSorting={true}
      nestedHeaders={this.nestedHeaders}
      columns={this.columns}
      autoUpdate={true}
      data={this.state.list}
      afterChange={this.afterChange}/>
      </div>
      )
  },
})

function mapStateToProps(state,props) {
  let { routes,tasks } = state

  return {tasks,routes}
}


export default connect(mapStateToProps)(LogbookRebolt)



/** WEBPACK FOOTER **
 ** ./src/app/containers/LogbookRebolt.js
 **/